import tw from "twin.macro"

export const H4 = tw.h4`
 text-header 
 text-center 
 font-sans
 text-2xl
 font-semibold
 `
